import { defineComponent as h, useAttrs as C, ref as n, computed as d, watch as N, onMounted as b, openBlock as p, createElementBlock as v, normalizeClass as s, unref as o, normalizeStyle as f, createElementVNode as c, renderSlot as g, createCommentVNode as y } from "vue";
import { imageProps as z, imageEmits as B } from "./image.js";
import { useNamespace as I } from "../../hooks/use-namespace.js";
import "../../hooks/use-z-index.js";
import "./image.css";
const V = ["src"], $ = h({
  name: "ApImage"
}), D = /* @__PURE__ */ h({
  ...$,
  props: z,
  emits: B,
  setup(_, { emit: E }) {
    const l = _, u = E, k = C(), i = n(), r = n(!0), a = n(!1), t = I("image"), S = d(() => k.style), L = d(() => {
      const { fit: e } = l;
      return e ? { objectFit: e } : {};
    }), m = () => {
      r.value = !0, a.value = !1, i.value = l.src;
    };
    function w(e) {
      r.value = !1, a.value = !1, u("load", e);
    }
    function A(e) {
      r.value = !1, a.value = !0, u("error", e);
    }
    return N(
      () => l.src,
      () => {
        m();
      }
    ), b(() => {
      m();
    }), (e, j) => (p(), v("div", {
      class: s([o(t).b()]),
      style: f(S.value)
    }, [
      c("img", {
        src: i.value,
        class: s([o(t).e("inner"), r.value && o(t).is("loading")]),
        style: f(L.value),
        alt: "",
        onLoad: w,
        onError: A
      }, null, 46, V),
      r.value || a.value ? (p(), v("div", {
        key: 0,
        class: s(o(t).e("wrapper"))
      }, [
        r.value ? g(e.$slots, "placeholder", { key: 0 }, () => [
          c("div", {
            class: s(o(t).e("placeholder"))
          }, null, 2)
        ]) : a.value ? g(e.$slots, "error", { key: 1 }, () => [
          c("div", {
            class: s(o(t).e("error"))
          }, "Error", 2)
        ]) : y("", !0)
      ], 2)) : y("", !0)
    ], 6));
  }
});
export {
  D as default
};
